import React from 'react';
import { Menu, MenuButton } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import { TicketKey } from 'flow/types/EntityKeys';

import StatusChipPicker from './StatusChipPicker';

type Props = {
    ticketKey: TicketKey;
    chipClassName: string;
    children: React.ReactNode;
};

const EditableStatusChip = ({ ticketKey, chipClassName, children }: Props) => (
    // Stop the click here so it doesn't bubble to the row's onClick
    // (which navigates to the ticket) when opening the status picker.
    <div className="flex" onClick={(event) => event.stopPropagation()}>
        <Menu>
            {({ open }) => (
                <>
                    <MenuButton
                        className={twMerge(chipClassName, 'hover:darken-10')}
                    >
                        {children}
                    </MenuButton>
                    {open ? <StatusChipPicker ticketKey={ticketKey} /> : null}
                </>
            )}
        </Menu>
    </div>
);

export default React.memo(EditableStatusChip);
